// navigator.clipboard só existe em contexto seguro (HTTPS ou localhost); acessando por IP em HTTP usa o execCommand
const copyWithTextarea = text => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
        return document.execCommand('copy');
    } finally {
        document.body.removeChild(textarea);
    }
};

export const copyToClipboard = async text => {
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (e) {
            return copyWithTextarea(text);
        }
    }
    return copyWithTextarea(text);
};

export default copyToClipboard;
